<template>
    <div id="contenedor-generador-plantilla-desktop">
      <v-card>
        <v-card-title class="secondary--text">
          Generador de plantillas {{modulo}}
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container >
            <v-row >
              <v-col>
                <plantillas-listado
                  :modulo="modulo"
                  :datos="datos"
                  :idarchivo="idarchivo">
                </plantillas-listado>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
</template>

<script>

import plantillasListado from '@/components/administracion/configuracion/plantillas/generador/listado/Desktop.vue';

export default {
  name: 'ConfiguracionPlantillasGeneradorDesktop',
  components: {
    plantillasListado,
  },
  props: {
    modulo: {
      type: String,
      required: true,
    },
    datos: {
      type: Object,
      required: false,
      default() { return {}; },
    },
    idarchivo: {
      type: String,
      required: false,
    },
  },
  methods: {
    cerrar() {
      this.$emit('cerrarGenerarNuevaPlantilla');
    },
  },
};

</script>

<style lang="scss" scoped>

</style>
